var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warp-box"},[_c('span',{staticClass:"jump",on:{"click":function($event){return _vm.clickFn(_vm.item)}}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }